import type { PackageEstimateRange } from '@openx/types/package.ts';

export const getEstimateRangeText = (
  estimate?: PackageEstimateRange | null,
  format: (v: number) => string = v => v.toString(),
  suffix = ''
): string | null => {
  if (!estimate) return null;
  const low = format(Number(estimate.low));
  const high = format(Number(estimate.high));
  return `${low}${suffix} - ${high}${suffix}`;
};
